var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "approval-attachments" },
    [
      _vm._l(_vm.files, function (file, index) {
        return _c(
          "div",
          {
            key: file.uid || file.id || index,
            staticClass: "approval-attachment-row",
          },
          [
            _c(
              "button",
              {
                staticClass: "approval-file-name",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.view(file)
                  },
                },
              },
              [_vm._v(_vm._s(file.name || file.fileName || "附件"))]
            ),
            _c(
              "button",
              {
                staticClass: "approval-file-action",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.view(file)
                  },
                },
              },
              [_vm._v("查看")]
            ),
            _c(
              "button",
              {
                staticClass: "approval-file-action",
                attrs: { type: "button", disabled: _vm.downloading === file },
                on: {
                  click: function ($event) {
                    return _vm.download(file)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.downloading === file ? "下载中…" : "下载"))]
            ),
            _vm.removable
              ? _c(
                  "button",
                  {
                    staticClass: "approval-file-remove",
                    attrs: { type: "button", "aria-label": "移除附件" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("remove", file)
                      },
                    },
                  },
                  [_vm._v("×")]
                )
              : _vm._e(),
          ]
        )
      }),
      _vm.selected
        ? _c("approval-file-preview", {
            key: _vm.selected.url,
            attrs: { file: _vm.selected },
            on: {
              close: function ($event) {
                _vm.selected = null
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }